import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var createAudioParamRenderer = function createAudioParamRenderer(automationEventList) {
  return {
    replay: function replay(audioParam) {
      var _iterator = _createForOfIteratorHelper(automationEventList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var automationEvent = _step.value;
          if (automationEvent.type === 'exponentialRampToValue') {
            var endTime = automationEvent.endTime,
              value = automationEvent.value;
            audioParam.exponentialRampToValueAtTime(value, endTime);
          } else if (automationEvent.type === 'linearRampToValue') {
            var _endTime = automationEvent.endTime,
              _value = automationEvent.value;
            audioParam.linearRampToValueAtTime(_value, _endTime);
          } else if (automationEvent.type === 'setTarget') {
            var startTime = automationEvent.startTime,
              target = automationEvent.target,
              timeConstant = automationEvent.timeConstant;
            audioParam.setTargetAtTime(target, startTime, timeConstant);
          } else if (automationEvent.type === 'setValue') {
            var _startTime = automationEvent.startTime,
              _value2 = automationEvent.value;
            audioParam.setValueAtTime(_value2, _startTime);
          } else if (automationEvent.type === 'setValueCurve') {
            var duration = automationEvent.duration,
              _startTime2 = automationEvent.startTime,
              values = automationEvent.values;
            audioParam.setValueCurveAtTime(values, _startTime2, duration);
          } else {
            throw new Error("Can't apply an unknown automation.");
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
};